const projectDataReducer = (data = "unset", action) => {
    let cardsGroups
    switch(action.type){
        case 'SET_DATA':
            data = action.data
            return data;
        case 'ADD_CARDS':
            let cardsGroupsData = { ...data.cards_groups }
            let carsGroupId = action.data.id
            cardsGroupsData[carsGroupId] = {
                ...cardsGroupsData[carsGroupId],
                cards: action.data.cards
            }
            return {
                ...data, 
                cards_groups : {
                    ...data.cards_groups,
                    ...cardsGroupsData
                }
            } 
        case 'ADD_CARDSGROUPS':
            return {
                ...data, 
                cards_groups : {
                    ...data.cards_groups,
                    ...action.data
                }
            }  
        case 'EDIT_CARDS':
            return { 
                ...data, 
                cards_groups: {
                    ...data.cards_groups,
                    ...action.data
                }
            }
        case 'DELETE_CARDS':
            cardsGroups = {...data.cards_groups}
            for (const cardsGroupId of action.data) {
                let id = cardsGroupId.toString()
                delete cardsGroups[id]
            }
            return { 
                ...data, 
                cards_groups: cardsGroups
            }
        case 'DELETE_CARDS_FROM_CARDSGROUPS':
            cardsGroups = {...data.cards_groups}
            for (const cardsGroupId of action.data) {
                let id = cardsGroupId.toString()
                if (cardsGroups[id]) {
                    delete cardsGroups[id].cards;
                }
            }
            return { 
                ...data, 
                cards_groups: cardsGroups
            }   
        case 'ADD_AREAS':
            let areas = action.data
            return {
                ...data, 
                areas : {
                    ...areas
                }
            }  
        case 'EDIT_FIGURES':
            return {
                ...data,
                figures: {
                    ...data.figures,
                    ...action.figuresData
                },
                figuregroups_map: {
                    ...data.figuregroups_map,
                    ...action.figuregroupsMap
                }
            }
        case 'ADD_FIRST_CARD_DESCRIPTION':
            cardsGroups = {...data.cards_groups}
            for (const cardsGroupId in action.data) {
                cardsGroups[cardsGroupId].attributes.first_card_description = action.data[cardsGroupId];
            }
            return { 
                ...data, 
                cards_groups: cardsGroups
            }
        default:
            return data;
    }
}

export default projectDataReducer;